module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "girl2"
    }
  }, [_c('ellipse', {
    attrs: {
      "id": "girl2_right_wheel_2",
      "cx": "5608.5",
      "cy": "417.5",
      "fill": "#91713D",
      "rx": "21.5",
      "ry": "32.5"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "girl2_right_wheel_1",
      "cx": "5610.5",
      "cy": "418",
      "fill": "#A98448",
      "rx": "15.5",
      "ry": "26"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_frame",
      "fill": "#FBD79E",
      "d": "M5600.86 386.6l19.04-17.05v-22c0-2.5 2.04-4.55 4.55-4.55h2.65c1.05 0 1.9.85 1.9 1.9 0 1.06-.85 1.9-1.9 1.9h-3.27v36.66h-3.93v-6.66l-15.02 13.62c-3.14 2.85-4.92 6.88-4.92 11.1v31.92c-4.5.32-6.52 6.84-6.06 19.56h-3.8c-.55-13.86 1.38-21.33 5.77-22.42v-32.8c0-4.27 1.8-8.33 5-11.18z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_handle",
      "fill": "#91713D",
      "d": "M5623 343h8c1.1 0 2 .9 2 2s-.9 2-2 2h-8v-4z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl2_right_foot_rest",
      "width": "22",
      "height": "3",
      "x": "5590",
      "y": "449",
      "fill": "#A98448"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "girl2_seat",
      "fill": "#BC9555",
      "points": "5619.25243 384 5666 384 5645.49669 408.266667 5645.49669 412 5594 412 5594 408.266667"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "girl2_back",
      "fill": "#BC9555",
      "points": "5623 377 5663 377 5663 346 5623 346"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_shoe",
      "fill": "#91713D",
      "d": "M5602.76 444.28c2.94-1.4 6.88-1.8 8.46-.44.67 1.92.96 6.16.67 8.15-2.54 0-12.5.02-15.57 0-2.7-.04-2.97-3.25-1.22-4.6 1.23-.63 4.72-1.7 7.66-3.12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_ankle",
      "fill": "#E2B56C",
      "d": "M5602.1 436h6.94c-.06 4.1.26 6.93.96 8.5-1.6 1.54-6 1.5-9.48 1.5-1.66 0-4.3-.23-.8-1.66 1.85-.74 2.64-3.52 2.38-8.34z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_leg_bottom",
      "fill": "#91713D",
      "d": "M5605 400c3.3 0 6 2.7 6 6v34h-12v-34c0-3.3 2.7-6 6-6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_leg_top",
      "fill": "#91713D",
      "d": "M5631.25 379.75c2.33 2.34 2.33 6.14 0 8.47l-22.03 22.03c-2.33 2.33-6.13 2.33-8.47 0-2.33-2.34-2.33-6.14 0-8.47l22.03-22.03c2.33-2.33 6.13-2.33 8.47 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_shoe",
      "fill": "#91713D",
      "d": "M5618.76 448.28c2.94-1.4 6.88-1.8 8.46-.44.67 1.92.96 6.16.67 8.15-2.54 0-12.5.02-15.57 0-2.7-.04-2.97-3.25-1.22-4.6 1.23-.63 4.72-1.7 7.66-3.12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_ankle",
      "fill": "#E2B56C",
      "d": "M5620.1 440h6.94c-.06 4.1.26 6.93.96 8.5-1.6 1.54-6 1.5-9.48 1.5-1.66 0-4.3-.23-.8-1.66 1.85-.74 2.64-3.52 2.38-8.34z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_leg_bottom",
      "fill": "#91713D",
      "d": "M5623 405c3.3 0 6 2.7 6 6v34h-12v-34c0-3.3 2.7-6 6-6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_leg_top",
      "fill": "#91713D",
      "d": "M5653.22 380.74c2.37 2.3 2.37 6.06 0 8.38l-25.83 25.14c-2.4 2.32-6.24 2.32-8.62 0-2.37-2.3-2.37-6.06 0-8.38l25.83-25.14c2.4-2.32 6.24-2.32 8.62 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_hip",
      "fill": "#91713D",
      "d": "M5623 374h31v4.5c0 8.56-6.94 15.5-15.5 15.5-8.56 0-15.5-6.94-15.5-15.5V374z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl2_left_foot_rest",
      "width": "22",
      "height": "3",
      "x": "5608",
      "y": "453",
      "fill": "#A98448"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_frame",
      "fill": "#FBD79E",
      "d": "M5642.1 389.88l20.66-18.3v-23.96c0-2.55 2.07-4.62 4.62-4.62h2.65c1.1 0 1.97.88 1.97 1.97 0 1.1-.88 1.97-1.97 1.97h-3.4v47.42h-9.8l5.93-6.8v-9.32l-16.7 15.95c-2.96 2.82-4.64 6.74-4.64 10.84v24.4c-9.43 0-13.96 8.85-13.57 26.56H5623c.32-20.16 5-30.28 14.06-30.35V401.1c0-4.28 1.84-8.37 5.05-11.22z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_handle",
      "fill": "#91713D",
      "d": "M5667 343h8c1.1 0 2 .9 2 2s-.9 2-2 2h-8v-4z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "girl2_left_wheel_9",
      "cx": "5662.5",
      "cy": "425.5",
      "fill": "#91713D",
      "rx": "23.5",
      "ry": "32.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_wheel_8",
      "fill": "#A98448",
      "d": "M5650 408.8c1.8 1.6 6.44 5.66 13.93 12.2l2.07-1.58c-2.04-11.56-3.26-18.36-3.64-20.42-5.16.67-10.57 5.36-12.36 9.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_wheel_7",
      "fill": "#A98448",
      "d": "M5646 425h16.5l.5-2.5c-7.92-6.57-12.5-10.4-13.78-11.5-1.65 2.34-3.33 10.3-3.2 14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_wheel_6",
      "fill": "#A98448",
      "d": "M5649.67 441c.75-.64 5.52-4.54 14.33-11.7l-.8-2.3H5646c-.15 3.08 1.9 11.36 3.67 14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_wheel_5",
      "fill": "#A98448",
      "d": "M5662.43 452c.4-1.86 1.6-8.5 3.57-19.9l-1.95-1.1c-8.48 7.24-13.16 11.25-14.05 12.04 1.33 4.33 9.07 9.02 12.43 8.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_wheel_4",
      "fill": "#A98448",
      "d": "M5677 442.17c-.87-1.15-3.64-4.87-8.3-11.17l-1.22.86c-2.06 12.1-3.23 18.82-3.48 20.14 5.96.03 11-6.25 13-9.83z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_wheel_3",
      "fill": "#A98448",
      "d": "M5682 427h-10.23l-.77 2.44c4.7 6.1 7.4 9.63 8.1 10.56 1.82-3.7 2.9-9.68 2.9-13z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_wheel_2",
      "fill": "#A98448",
      "d": "M5677.35 408c-.5 1-2.63 5.52-6.35 13.6l.97 3.4h10c.3-5.2-1.94-12.97-4.62-17z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_wheel_1",
      "fill": "#A98448",
      "d": "M5664 399l3.33 20.3 1.46.7c3.8-8.76 5.86-13.5 6.2-14.2-1.32-2.53-6.2-6.86-11-6.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_hand",
      "fill": "#E2B56C",
      "d": "M5602.75 376.6c-1.06.92-2.27.73-4.1 1.13-2.15.46-4.68 2.8-7.65 3.83-.3.7 2 1.36 3.14.9 1.16-.45 2.08-.84 2.4-.92.32-.1.53.2.4.45-.15.25-7.67 7.08-7.9 7.57-.23.5.56 1.42 1.1 1.24.52-.16 6.6-5.43 6.83-5.5.23-.05.33.22.32.38-.02.15-6.66 5.6-6.78 5.95-.12.35.75 1.26 1.04 1.2.3-.08 6.8-5.63 7.05-5.65.25-.02.4.2.36.4-.06.2-6.5 5.33-6.65 5.7-.13.4.68 1.3 1.02 1.16.35-.15 6.8-5.36 6.97-5.35.16 0 .25.13.25.28 0 .16-4.63 4.28-4.75 4.65-.13.37.42 1.1.83.95.4-.17 11.4-10.5 12.06-11.03 2.14-1.78 3.3-4.88 1.17-7.3-2.12-2.4-4.84-1.97-7.12-.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_arm_bottom",
      "fill": "#E2B56C",
      "d": "M5619.75 366.48c1.75 1.88 1.65 4.82-.23 6.58l-14.7 13.7c-1.87 1.74-4.82 1.64-6.57-.24s-1.65-4.82.23-6.58l14.7-13.7c1.87-1.74 4.82-1.64 6.57.24z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_arm_top",
      "fill": "#E2B56C",
      "d": "M5631.43 342.55c2.36 1.23 3.26 4.1 2 6.4l-12.3 22.54c-1.25 2.3-4.2 3.17-6.56 1.95-2.36-1.23-3.26-4.1-2-6.4l12.3-22.54c1.25-2.3 4.2-3.17 6.56-1.95z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_sleeve",
      "fill": "#BC9555",
      "d": "M5630.38 341.6c2.3 1.3 3.26 4.24 2.17 6.73l-4.67 10.67-9.88-5.5 5.84-10.02c1.36-2.34 4.23-3.16 6.54-1.87z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_torso",
      "fill": "#A98448",
      "d": "M5628.93 344.78c3.7-6.43 16.85-6.3 20.93 0 2.72 4.2 4.77 13.95 6.14 29.22h-33c1.5-15.2 3.46-24.93 5.93-29.22z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_hand",
      "fill": "#E2B56C",
      "d": "M5640.75 382.6c-1.06.92-2.27.73-4.1 1.13-2.15.46-4.68 2.8-7.65 3.83-.3.7 2 1.36 3.14.9 1.16-.45 2.08-.84 2.4-.92.32-.1.53.2.4.45-.15.25-7.67 7.08-7.9 7.57-.23.5.56 1.42 1.1 1.24.52-.16 6.6-5.43 6.83-5.5.23-.05.33.22.32.38-.02.15-6.66 5.6-6.78 5.95-.12.35.75 1.26 1.04 1.2.3-.08 6.8-5.63 7.05-5.65.25-.02.4.2.36.4-.06.2-6.5 5.33-6.65 5.7-.13.4.68 1.3 1.02 1.16.35-.15 6.8-5.36 6.97-5.35.16 0 .25.13.25.28 0 .16-4.63 4.28-4.75 4.65-.13.37.42 1.1.83.95.4-.17 11.4-10.5 12.06-11.03 2.14-1.78 3.3-4.88 1.17-7.3-2.12-2.4-4.84-1.97-7.12-.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_arm_bottom",
      "fill": "#E2B56C",
      "d": "M5664.76 366.48c1.74 1.88 1.64 4.82-.23 6.57l-17.77 16.7c-1.86 1.75-4.78 1.65-6.52-.23-1.74-1.88-1.64-4.82.23-6.57l17.77-16.7c1.86-1.75 4.78-1.65 6.52.23z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_arm_top",
      "fill": "#E2B56C",
      "d": "M5647.83 341.45c2.46-1.12 5.37-.08 6.52 2.3l11.2 23.44c1.13 2.4.07 5.23-2.38 6.35-2.46 1.12-5.37.08-6.52-2.3l-11.2-23.44c-1.13-2.4-.07-5.23 2.38-6.35z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_sleeve",
      "fill": "#BC9555",
      "d": "M5646.93 340.5c2.43-1.17 5.33-.2 6.6 2.22l5.47 10.33-10.4 4.95-4.24-10.9c-1-2.56.14-5.46 2.57-6.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_neck",
      "fill": "#D3A862",
      "d": "M5636.18 337.1c2.3-1.5 4.4-1.45 6.72 0-.08 2.75-.62 3.8 1.1 5.3-2 3.4-6.98 3.54-9 0 .98-1.5 1.47-3.3 1.18-5.3z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "girl2_head"
    }
  }, [_c('path', {
    attrs: {
      "id": "girl2_face",
      "fill": "#D3A862",
      "d": "M5638.43 298c17.05.07 17.7 10.03 17.55 18.4 8.3-.7 2.12 15.57-4 12.8-.74 2.07-2.82 9.93-14.05 9.8-11.24-.13-14.75-12.75-14.92-21.08-.15-8.33 1.18-19.98 15.43-19.92z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_mouth_bottom",
      "fill": "#BC9555",
      "fill-rule": "nonzero",
      "d": "M5634 333.1c.92.28 6.07.36 7.78-.08.92-.22-1.14 1.98-4.57 1.98-3.43 0-3.2-1.9-3.2-1.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_mouth_top",
      "fill": "#BC9555",
      "fill-rule": "nonzero",
      "d": "M5633 332.66c0-.9.53-1.66 3.28-1.66 1.9 0 4.96 1.24 6.5.7.3-.15.3.2-.1.4-1.97.9-3.87.9-6.77.9-1.9-.07-2.9-.34-2.9-.34z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_nose",
      "fill": "#BC9555",
      "d": "M5635.5 319.77c0-.98 3.06-1.07 3.06 0 0 1.06.98 6.62 0 7.6-.98 1-3.86.66-4.3 0-.45-.65-.36-1.72.6-2.02.97-.3.65-4.6.65-5.58z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_eye_whites",
      "fill": "#FBD79E",
      "d": "M5640 321.36c1.47-3.94 8.02-4.54 9-1.13 0 4.6-7.93 5-9 1.13z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "girl2_left_pupil",
      "cx": "5643",
      "cy": "321",
      "r": "2",
      "fill": "#91713D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_eye_whites",
      "fill": "#FBD79E",
      "d": "M5633 321.36c-1.47-3.94-8.02-4.54-9-1.13 0 4.6 7.93 5 9 1.13z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "girl2_right_pupil",
      "cx": "5627",
      "cy": "321",
      "r": "2",
      "fill": "#91713D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_left_brow",
      "fill": "#91713D",
      "d": "M5640.6 315.45c1.18-.55 7.38-.65 8.74 0 1.35.65.36 1.75-.6 1.5-.93-.25-6.55-.3-7.56 0-1 .3-1.76-.95-.58-1.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_right_brow",
      "fill": "#91713D",
      "d": "M5633.4 315.45c-1.18-.55-7.38-.65-8.74 0-1.35.65-.36 1.75.6 1.5.93-.25 6.55-.3 7.56 0 1 .3 1.76-.95.58-1.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl2_hair",
      "fill": "#91713D",
      "d": "M5636.86 303.54c5.6 6.53 12.37 12.58 14.75 14.77.52 4.84-2.33 16.8-3.52 18.7 1.7-.54 3.83-3.05 4.8-4.23-.1 1.4-.5 3.05-.67 3.6.7-.27 3.12-2.1 3.95-3.9v3.9c.75-1.03 2.98-5.2 3.54-7.74.55-2.55 8.54-35.5-22.84-33.55-22.88 1.44-19.2 35.74-13.75 40.74v-2.65c.96 1.68 1.34 1.82 2.47 3.2-.56-4.83-2.5-15.43-2.46-18.06 2.45-3.5 8.54-8.76 13.76-14.76z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1807c14c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_2/backgroundCharacters/girlTwo.vue
// module id = 665
// module chunks = 1